import Fota from '@leverege/api-ui-fota-management';
import { Attributes } from '@leverege/ui-attributes';
import Util from './Util';
const dType = Fota.Constants.Types.deviceType;
export default ({
  blueprint,
  deviceType
}) => ({
  name: `${deviceType?.id}.numStaleDevices`,
  objectType: blueprint.type,
  valueType: 'int',
  get: data => {
    const withCounters = Util.getWithCounters(data, {
      deviceType
    });
    return withCounters?.counters?.numStaleDevices;
  },
  load: data => Util.loadWithCounters(data, {
    deviceType
  }),
  displayName: `${Attributes.get('name', dType, deviceType)} Number of Stale Devices`,
  source: {
    type: Fota.Constants.Types.apiName,
    editable: false,
    creatable: false
  }
});